import { StyledElementWrapper } from './wrapper/wrapper.style';
import { StyledElementWrapperCenter } from './wrapperCenter/wrapperCenter.style';
import { StyledElementButton } from './button/button.style';
import { StyledElementHeaderTitle } from './headerTitle/headerTitle.style';
import { StyledElementHeaderDescription } from './headerDescription/headerDescription.style';

export {
  StyledElementButton,
  StyledElementWrapper,
  StyledElementWrapperCenter,
  StyledElementHeaderTitle,
  StyledElementHeaderDescription,
}


// WEBPACK FOOTER //
// ./src/utils/styledElements/index.js